module.exports = __webpack_public_path__ + "static/media/portugal.4e600f41.svg";